import {useState} from "react";

import {PermitApplicationService} from "permitapplication/service";
import {useNavigateWithReload} from "base/navigation/hooks";

import {MaterialForm} from "material/presentational/form";
import {AddNewInlineItemButton, AddNewInlineItemFormBox} from "base/shared/components";
import {useErrors} from "base/error/provider/ErrorProvider";

const CreateMaterialDataContent = ({permitId, displayFees}) => {
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const [mode, setMode] = useState("button");

    const handleFormSubmit = material => {
        PermitApplicationService.createMaterial(permitId, material)
            .then(createdMaterial => {
                setMode("button");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    return mode === "button" ? (
        <AddNewInlineItemButton
            onClick={() => {
                setMode("create");
            }}
            label="Acrescentar material"
        />
    ) : mode === "create" ? (
        <AddNewInlineItemFormBox label="Acrescentar material">
            <MaterialForm
                permitId={permitId}
                displayFees={displayFees}
                onSubmit={handleFormSubmit}
                onCancel={() => {
                    setMode("button");
                }}
            />
        </AddNewInlineItemFormBox>
    ) : null;
};

export default CreateMaterialDataContent;
